module.exports = __webpack_public_path__ + "img/MX-D082065A-BS.a812226d.png";